// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1NV6-","header":"ReportDetails_header__1VNUZ","title":"ReportDetails_title__3fiaO","left":"ReportDetails_left__1LfB6"};